import { Selector } from "@ngxs/store";
import { UserState } from "./user-state";
import { UserStateModel } from "./user-state-model";

export class UserSelectors {
  @Selector([UserState])
  static getUser(state: UserStateModel) {
    return state;
  }
}
